import axios from "@/services/axios.config";
import {getKonekoBudgetApiBaseUrl} from "@/utils/apiBasePreference";
import {
  mergeKonekoProjectNameAliases,
  registerKonekoProjectRename,
} from "@/config/konekoAConfig";

const REQ_MS = 12000;

function joinApi(base, path) {
  const b = String(base || "").replace(/\/?$/, "/");
  const p = String(path || "").replace(/^\//, "");
  return `${b}${p}`.replace(/([^:]\/)\/+/g, "$1");
}

function authHeaders() {
  const h = {Accept: "application/json", "Content-Type": "application/json"};
  try {
    const token = localStorage.getItem("token");
    if (token) h.Authorization = `JWT ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

/** Load shared rename aliases from koneko-budgets-service (best-effort). */
export async function fetchKonekoProjectNameAliases() {
  const base = getKonekoBudgetApiBaseUrl();
  const url = joinApi(base, "api/koneko/v1/projects/name-aliases/");
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), REQ_MS);
  try {
    const r = await fetch(url, {
      method: "GET",
      cache: "no-store",
      credentials: "omit",
      mode: "cors",
      headers: authHeaders(),
      signal: ctrl.signal,
    });
    clearTimeout(t);
    if (!r.ok) return null;
    const data = await r.json();
    if (data && data.aliases && typeof data.aliases === "object") {
      mergeKonekoProjectNameAliases(data.aliases);
      return data.aliases;
    }
    return null;
  } catch {
    clearTimeout(t);
    return null;
  }
}

/** After NekoHR project rename — sync budget string keys (Django + Express). */
export async function syncKonekoProjectRename(projectId, oldName, newName) {
  registerKonekoProjectRename(oldName, newName);
  try {
    const res = await axios.post(
      "api/koneko-a/projects/sync-rename/",
      {
        projectId,
        oldName: String(oldName || "").trim(),
        newName: String(newName || "").trim(),
      },
      {timeout: REQ_MS}
    );
    return res.data || {ok: true};
  } catch (err) {
    const detail =
      (err &&
        err.response &&
        err.response.data &&
        (err.response.data.error || err.response.data.detail)) ||
      (err && err.message) ||
      "sync-rename failed";
    return {ok: false, error: detail};
  }
}

export async function hydrateKonekoProjectNameAliases() {
  try {
    const {loadKonekoProjectNameAliasesFromStorage} = await import(
      "@/config/konekoAConfig"
    );
    loadKonekoProjectNameAliasesFromStorage();
  } catch {
    /* ignore */
  }
  await fetchKonekoProjectNameAliases();
}
